<template>
  <div class="multi-select-filter" ref="filterContainer">
    <div class="selected-values" @click="toggleDropdown">
      <div class="selected-values-content">
        <span v-if="selectedValues.length === 0" class="placeholder">{{ placeholder }}</span>
        <span v-else class="selected-count">{{ selectedValues.length }} sélectionné(s)</span>
      </div>
      <span class="arrow">▼</span>
    </div>
    <div v-if="isOpen" class="dropdown">
      <div class="dropdown-header">
        <button @click="selectAll" class="btn-action">Tout sélectionner</button>
        <button @click="clearAll" class="btn-action">Tout effacer</button>
      </div>
      <div class="options-list">
        <label v-for="option in options" :key="getOptionKey(option)" class="option-item">
          <input
            type="checkbox"
            :value="getOptionValue(option)"
            :checked="selectedValues.includes(getOptionValue(option))"
            @change="toggleOption(getOptionValue(option))"
          />
          <span>{{ getOptionLabel(option) }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelectFilter",
  props: {
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: "Sélectionner..."
    }
  },
  data() {
    return {
      selectedValues: [],
      isOpen: false
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const container = this.$refs.filterContainer;
      if (container && !container.contains(event.target)) {
        this.closeDropdown();
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    getOptionKey(option) {
      return typeof option === 'object' ? option.value : option;
    },
    getOptionValue(option) {
      return typeof option === 'object' ? option.value : option;
    },
    getOptionLabel(option) {
      return typeof option === 'object' ? option.label : option;
    },
    toggleOption(optionValue) {
      const index = this.selectedValues.indexOf(optionValue);
      if (index > -1) {
        this.selectedValues.splice(index, 1);
      } else {
        this.selectedValues.push(optionValue);
      }
      this.emitChange();
    },
    selectAll() {
      this.selectedValues = this.options.map(opt => this.getOptionValue(opt));
      this.emitChange();
    },
    clearAll() {
      this.selectedValues = [];
      this.emitChange();
    },
    emitChange() {
      this.$emit('update', this.selectedValues);
    }
  }
};
</script>

<style scoped>
.multi-select-filter {
  position: relative;
}

.selected-values {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  box-sizing: border-box;
}

.selected-values:hover {
  border-color: #999;
}

.selected-values-content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.placeholder {
  color: #999;
  font-size: 12px;
  background-color: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  cursor: inherit;
}

.selected-count {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.arrow {
  margin-left: 4px;
  font-size: 10px;
  color: #666;
  flex-shrink: 0;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  min-width: 200px;
  margin-top: 4px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

.dropdown-header {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.btn-action {
  flex: 1;
  padding: 4px 8px;
  font-size: 12px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
}

.btn-action:hover {
  background-color: #e8e8e8;
}

.options-list {
  overflow-y: auto;
  max-height: 250px;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
}

.option-item:hover {
  background-color: #f5f5f5;
}

.option-item input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
}

.option-item span {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardGRFA/MultiSelectFilter.vue